//错误发生范围
export type ErrorScope = 'cartDrawer' | 'pdp' | 'checkout' | 'bootstrap' | 'refresh' | 'system';

//错误类型枚举
export const ErrorCode = {
  NETWORK: 'NETWORK',
  TIMEOUT: 'TIMEOUT',
  RATE_LIMIT: 'RATE_LIMIT',
  VALIDATION: 'VALIDATION',
  CART_STOCK_LIMIT: 'STOCK_LIMIT',
  CART_SYNC_PENDING: 'CART_SYNC_PENDING',
  CART_SYNC_FAILED: 'CART_SYNC_FAILED',
  DISCOUNT_CODE_INVALID: 'DISCOUNT_CODE_INVALID',
  DISCOUNT_CODE_FAILED: 'DISCOUNT_CODE_FAILED',
  DATA_DISCOUNT_INCONSISTENCY: 'DATA_DISCOUNT_INCONSISTENCY',
  CART_REJECTED_VALIDATION: 'CART_REJECTED_VALIDATION',
  UNKNOWN: 'UNKNOWN'
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

//错误提醒方式
export type ErrorStrategy = 'TOAST' | 'MODAL' | 'SILENT' | 'INLINE';

//错误严重等级
export type ErrorCatalogEntry = {
  userMessageKey: string;
  level?: 'info' | 'warning' | 'error';
  strategy: ErrorStrategy;
  dedupeWindowMs?: number; //去重时间窗口
};

//错误处理策略
export type ErrorCatalogPolicy = {
  default: ErrorCatalogEntry;
  scopes?: Partial<Record<ErrorScope, Partial<ErrorCatalogEntry>>>;
};


export const ERROR_CATALOG: Record<ErrorCode, ErrorCatalogPolicy> = {
  [ErrorCode.NETWORK]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'error',
      strategy: 'TOAST',
      dedupeWindowMs: 2000
    }
  },
  [ErrorCode.TIMEOUT]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'error',
      strategy: 'TOAST',
      dedupeWindowMs: 2000
    }
  },
  [ErrorCode.RATE_LIMIT]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'warning',
      strategy: 'TOAST',
      dedupeWindowMs: 2000
    }
  },
  [ErrorCode.VALIDATION]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'warning',
      strategy: 'TOAST'
    }
  },
  [ErrorCode.CART_STOCK_LIMIT]: {
    default: {
      userMessageKey: 'stockLimitExceeded',
      level: 'warning',
      strategy: 'MODAL',
      dedupeWindowMs: 2000
    },
    scopes: {
      cartDrawer: {
        strategy: 'MODAL',
        dedupeWindowMs: 2000
      }
    }
  },
  [ErrorCode.CART_SYNC_FAILED]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'error',
      strategy: 'TOAST',
      dedupeWindowMs: 2000
    },
    scopes: {
      bootstrap: {
        strategy: 'SILENT'
      },
      refresh: {
        strategy: 'SILENT'
      }
    }
  },
  [ErrorCode.CART_SYNC_PENDING]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'warning',
      strategy: 'SILENT'
    },
    scopes: {
      cartDrawer: {
        strategy: 'SILENT'
      },
      checkout: {
        strategy: 'SILENT'
      },
      refresh: {
        strategy: 'SILENT'
      }
    }
  },
  [ErrorCode.DISCOUNT_CODE_INVALID]: {
    default: {
      userMessageKey: 'couponInvalid',
      level: 'warning',
      strategy: 'TOAST'
    }
  },
  [ErrorCode.DISCOUNT_CODE_FAILED]: {
    default: {
      userMessageKey: 'couponValidationFailed',
      level: 'error',
      strategy: 'TOAST'
    }
  },
  [ErrorCode.DATA_DISCOUNT_INCONSISTENCY]: {
    default: {
      userMessageKey: 'discountDataInconsistency',
      level: 'warning',
      strategy: 'TOAST'
    }
  },
  [ErrorCode.UNKNOWN]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'error',
      strategy: 'TOAST'
    }
  },
  [ErrorCode.CART_REJECTED_VALIDATION]: {
    default: {
      userMessageKey: 'addFailed',
      level: 'warning',
      strategy: 'INLINE'
    },
    scopes: {
      pdp: {
        strategy: 'INLINE',
        level: 'error'
      },
      cartDrawer: {
        strategy: 'TOAST',
        level: 'warning'
      }
    }
  }
};
